import ProbateBasicInformation from "../../../../features/bonds/probate/components/BasicInformation";
import EstateDetails from "../../../../features/bonds/probate/components/EstateDetails";
import PersonalRepresentatives from "../../../../features/bonds/probate/components/PersonalRepresentatives";
import ProbateAttorneyInformation from "../../../../features/bonds/probate/components/AttorneyInformation";
import ProbateRequestorInformation from "../../../../features/bonds/probate/components/RequestorInformation";
import ProbateDocumentUpload from "../../../../features/bonds/probate/components/DocumentUpload";
import { BillingInformationForm } from "../Helpers/BillingInformation";
import { ObligeeInformationForm } from "../Helpers/ObligeeInformation";
import {
  PROBATE_LAYOUT_VIEW,
  getSelectedStateLabel,
  standardStep,
} from "../bondWizardPageConfig.shared";

export default {
  layout: "standard",
  inlineTitle: () =>
    `Probate Bond Request for State of ${getSelectedStateLabel()}`,
  containerClassName: "p-6 mx-auto max-w-7xl",
  guestSupportContext: "Guest Probate Bond Request",
  hasDuplicateDialog: true,
  hasEsignatureDialog: true,
  duplicateBondUpdatePath: (bondId) => `/vermost-probate-bond-update/${bondId}`,
  duplicateMessage:
    "A similar probate bond request appears to have been submitted within the last 24 hours. Do you still want to proceed?",
  getIsGuest: (form) => form.isGuestRequest,
  isNextDisabled: (form) =>
    form.globalState?.basicInformation?.judgeStern === "No",
  supportOnGoBack: ({ setSupportModalOpen }) => () => {
    setSupportModalOpen(false);
  },
  steps: [
    standardStep(ProbateBasicInformation, "basicInformation", (ctx) => ({
      globalData: ctx.globalState,
      data: ctx.globalState.basicInformation,
      updateData: (data) => ctx.updateGlobalState("basicInformation", data),
      layoutView: PROBATE_LAYOUT_VIEW,
      errors: ctx.errors,
      setErrors: ctx.setErrors,
    })),
    standardStep(EstateDetails, "generalInformation", (ctx) => ({
      globalData: ctx.globalState,
      data: ctx.globalState.generalInformation,
      updateData: (data) => ctx.updateGlobalState("generalInformation", data),
      errors: ctx.errors,
      setErrors: ctx.setErrors,
    })),
    standardStep(PersonalRepresentatives, "guardianDetails", (ctx) => ({
      globalData: ctx.globalState,
      data: ctx.globalState.guardianDetails,
      updateData: (data) => ctx.updateGlobalState("guardianDetails", data),
      errors: ctx.errors,
      setErrors: ctx.setErrors,
      isGuest: ctx.isGuest,
    })),
    standardStep(ProbateAttorneyInformation, "attorneyInformation", (ctx) => ({
      globalData: ctx.globalState,
      data: ctx.globalState.attorneyInformation,
      updateData: (data) => ctx.updateGlobalState("attorneyInformation", data),
      errors: ctx.errors,
      setErrors: ctx.setErrors,
      isGuest: ctx.isGuest,
    })),
    standardStep(ObligeeInformationForm, "obligeeInformation", (ctx) => ({
      globalData: ctx.globalState,
      data: ctx.globalState.obligeeInformation,
      updateData: (data) => ctx.updateGlobalState("obligeeInformation", data),
      errors: ctx.errors,
      setErrors: ctx.setErrors,
    })),
    standardStep(ProbateRequestorInformation, "requestorInformation", (ctx) => ({
      globalData: ctx.globalState,
      data: ctx.globalState.requestorInformation,
      updateData: (data) => ctx.updateGlobalState("requestorInformation", data),
      errors: ctx.errors,
      setErrors: ctx.setErrors,
    })),
    standardStep(ProbateDocumentUpload, "documentUpload", (ctx) => ({
      globalData: ctx.globalState,
      data: ctx.globalState.documentUpload,
      updateData: (data) => ctx.updateGlobalState("documentUpload", data),
      errors: ctx.errors,
      setErrors: ctx.setErrors,
    })),
    standardStep(BillingInformationForm, "billingInformation", (ctx) => ({
      globalData: ctx.globalState,
      data: ctx.globalState.billingInformation,
      updateData: (data) => ctx.updateGlobalState("billingInformation", data),
      errors: ctx.errors,
      setErrors: ctx.setErrors,
      isGuest: ctx.isGuest,
    })),
  ],
};
